import React from "react";
import { Router } from "./routing";
import {
  AuthApiProvider,
  AuthProvider,
  ExtensionBridgeProvider,
  SettingsProvider,
} from "./hooks";

export const App: React.FC = () => {
  return (
    <AuthProvider>
      <AuthApiProvider>
        <ExtensionBridgeProvider>
          <SettingsProvider>
            <Router />
          </SettingsProvider>
        </ExtensionBridgeProvider>
      </AuthApiProvider>
    </AuthProvider>
  );
};
